<template>
  <VoteKickListCard />
</template>
<script>
import VoteKickListCard from "./components/VoteKickListCard.vue";
export default {
  components: { VoteKickListCard },
};
</script>
s